import React from 'react';
import { Button } from "reactstrap";

import './RoundedButton.scss';

const RoundedButton = props => {
    return <Button {...props} className={"rounded-button " + props.className} />
}

export default RoundedButton;